import { client, getFailType, getSuccessType } from 'common/api'

export const ACTION_TYPES = {
  GET_PRODUCTS: 'GET_PRODUCTS',
}

export const getProducts = async (dispatch) => {
  dispatch({
    type: ACTION_TYPES.GET_PRODUCTS,
  })

  const response = await client.fetch(Urls['apiV01:favoriteProductsList']())

  if (response.ok) {
    dispatch({
      type: getSuccessType(ACTION_TYPES.GET_PRODUCTS),
      payload: response.data,
    })
  } else {
    dispatch({ type: getFailType(ACTION_TYPES.GET_PRODUCTS) })
  }
}
